<template>
  <div>
    <AdminMasterLayout>
      <section class="overhead">
        <div
          class="overhead-1 d-flex justify-content-between py-5 wallet-header"
        >
          <div>
            <h5 class="">{{ $t("text.iReport.report") }}</h5>

            <h6>{{ $t("text.iReport.orderHistory") }}</h6>
          </div>
          <div class="col-md-4 date_picker_m">
            <div class="">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#370F70"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>

        <div class="sub-nav">
          <ul class="d-flex">
            <li
              @click="() => (tabName = 'consumption')"
              :class="tabName === 'consumption' ? 'active-nav' : null"
              class="mr-5 pb-3 px-1"
            >
              {{ $t("text.iReport.consumption") }}
            </li>
            <li
              @click="() => (tabName = 'tankReport')"
              :class="tabName === 'tankReport' ? 'active-nav' : null"
            >
              {{ $t("text.iReport.tankReport") }}
            </li>
          </ul>
        </div>
      </section>
      <Consumption
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDatee="startDate"
        :endDatee="endDate"
        v-show="tabName === 'consumption'"
      />
      <TankReport
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDatee="startDate"
        :endDatee="endDate"
        v-show="tabName === 'tankReport'"
      />
    </AdminMasterLayout>
  </div>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import TankReport from "./Tank_Report";
import Consumption from "./Consumption";
export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "Walletconsumption",
  components: {
    AdminMasterLayout,
    Consumption,
    TankReport,
    //     Highcharts: Chart,
    //     VueApexCharts,
    //     VueperSlides,
    //     VueperSlide,
  },
  data() {
    return {
      tabName: this.$route.query.tab === "tanks" ?   "tankReport" : "consumption",
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      // pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
    };
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  mounted() {
    // if (this.$route.query.changing === true) {
    //   this.tabName = "tankReport";
    //   // console.log("treport");
    // }
  },
};
</script>

<style scoped>
.wallet-header {
  width: 90%;
  margin: auto auto;
}
.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 14px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}
@media screen and (max-width: 575px) {
  .overhead-1 {
    flex-flow: column wrap !important;
  }
}
</style>
